import FormData from 'form-data';

import {ENDPOINTS} from 'constants/endpoints';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {apiConfig, HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'libs/api/api';

const STORE_ID = '1';

// todo unite with the same function from mobile platform
/**
 * get Apple Pay client secret
 * @param {string} paymentMethodId - id from Apple pay PaymentRequest
 * @param {string} formKey - client formKey
 * @return {Promise} - response with from getApplePayClientSecret endpoint
 */
export async function getApplePayClientSecret(
    paymentMethodId: string,
    formKey: string,
): Promise<string | null> {
    const data = new FormData();
    data.append('payment[payment_method_id]', paymentMethodId);
    data.append('payment[method]', PAYMENTS.METHOD_APPLE_PAY);
    data.append('payment[platform]', 'desktop');
    data.append('payment[walkway]', 'checkout');
    data.append('form_key', formKey);

    try {
        const req = await apiConfig.instanceGusaBackend({
            data,
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.MULTIPART_FORM_DATA,
                [HTTP_REQUEST_HEADER.STORE]: STORE_ID,
            },
            method: 'post',
            url: `${ENDPOINTS.CHECKOUT_GET_APPLE_CLIENT_SECRET}`,
        });
        return req.data.client_secret;
    } catch (error) {
        return null;
    }
}
